var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "image-alt"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.4375 12.6562C35.4375 19.6461 29.7711 25.3125 22.7813 25.3125C15.7914 25.3125 10.125 19.6461 10.125 12.6562C10.125 5.6664 15.7914 0 22.7813 0C29.7711 0 35.4375 5.6664 35.4375 12.6562Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8273 33.1735C55.8528 32.6863 54.6759 32.8773 53.9054 33.6477L35.1228 57.4929L21.6619 43.4564C20.6579 42.7871 19.3211 42.9195 18.4679 43.7727L0.0078125 65.8126V75.9376C0.0078125 78.7335 2.27437 81.0001 5.07031 81.0001H75.9453C78.7413 81.0001 81.0078 78.7335 81.0078 75.9376V53.1563L56.8273 33.1735Z",
    fill: "#D9D9D9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageAlt);
export default __webpack_public_path__ + "static/media/image-alt.5194c5960678f8ee835603b8da2e173e.svg";
export { ForwardRef as ReactComponent };